import AttendeeList from './AttendeeList'

export default AttendeeList
